import React from "react";
import "./OpenDocumentModal.css";
import close from "../../Assets/close.svg";
import pdf from "../../Assets/PDF.svg";

const OpenDocumentModal = ({ document, onClose }) => {
  return (
    <div className="modal-overlay">
      <div className="openDocument-container">
        <button className="close-btn" onClick={onClose}>
          <img src={close} alt="" />
        </button>
        <div className="file-info">
          <div className="file-icon">
            <img src={pdf} alt="" />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              marginLeft: "10px",
            }}>
            <span
              style={{
                color: "#344054",
                fontSize: "15px",
                fontWeight: "500",
              }}>
              {document.docName}
            </span>
            <span
              style={{
                color: "#475467",
                fontSize: "15px",
                fontWeight: "400",
              }}>
              200 KB – 100% uploaded
            </span>
          </div>
        </div>
        <hr />
        <img src="" alt="" className="document-preview"/>
        <div className="modal-footer">
          <button className=" go-back">Go Back</button>
          <button className="next-btn">Verify</button>
        </div>
      </div>
    </div>
  );
};
export default OpenDocumentModal;
